function resolveBaseUrlApi(): string {
    if (typeof window === 'undefined' || !window.location || !window.location.hostname) {
        return 'https://dev.api.kossaya.id/';
    }

    const host = window.location.hostname.toLowerCase();

    // 1. Central Superadmin Portal (admin.localhost, admin.kossaya.id, central.kossaya.id)
    if (
        host === 'admin.localhost' ||
        host === 'central.localhost' ||
        host === 'admin.kossaya.id' ||
        host === 'central.kossaya.id' ||
        host === 'kossaya.id' ||
        host === 'www.kossaya.id' ||
        host === 'kartu.kossaya.com' ||
        host === 'kartu.kossaya.id' ||
        host === 'kartu.dev.kossaya.com'
    ) {
        return 'https://dev.api.kossaya.id/';
    }

    // 2. Localhost Subdomain for Tenants (e.g. zone.localhost:4200, demo.localhost:4200)
    if (host.endsWith('.localhost')) {
        const subdomain = host.replace('.localhost', '');
        return `https://dev.api.kossaya.id/`;
    }

    // 3. Local Test Domains (e.g. admin.kossaya.test, demo.kossaya.test)
    if (host.endsWith('.kossaya.test') || host.endsWith('.test')) {
        const subdomain = host.split('.')[0];
        if (subdomain === 'admin' || subdomain === 'central') {
            return 'https://api.kossaya.id/';
        }
        return `https://${subdomain}.api.kossaya.id/`;
    }

    // 4. Wildcard Tenant Subdomain (e.g. zone.kossaya.id -> https://zone.api.kossaya.id/)
    if (host.endsWith('.kossaya.id')) {
        const subdomain = host.replace('.kossaya.id', '');
        return `https://${subdomain}.dev.api.kossaya.id/`;
    }

    if (host.endsWith('.kossaya.com')) {
        const subdomain = host.replace('.kossaya.com', '');
        return `https://${subdomain}.dev.api.kossaya.com/`;
    }

    // 5. Default fallback for plain localhost:4200 / 127.0.0.1
    return 'https://dev.api.kossaya.id/';

}

export const environment = {
    production: false,
    https: 'https://',
    get baseurl_api(): string {
        return resolveBaseUrlApi();
    },
    baseurlStorage: 'https://ezgate.co.id/api_dev/',
    pathImg: '',
    path: '',
    auth: 'api/v1/auth/login',
    register: 'register',
    token: '',
    refresh_token: 'auth/refresh',
    img_default:
        'https://zeus.awh.co.id/awh_pos/images/k4m3dNY7iv416BvZCtKgMsagFVlI6kHTVIpcq8TiA-AhZlmGJYgTV4PBHHTiGDk9JLzi9Lh6kfGcirloU39_xfJcfF7FsDol4NmfI-IjzLUyerd7uXyZkaFuaEYGbITi',
    mqtt: {
        username: 'dhivapos',
        password: 'FurlaRasaMelon2024',
    },
};
